import styled from "styled-components";

import { StudentApp, StudentMain } from "./studentPortal.styles";

export const StudentViewportApp = styled(StudentApp)`
  height: var(--real-vh);
  min-height: 0;
  grid-template-rows: minmax(0, 1fr);
  overflow: hidden;

  > aside {
    height: 100%;
    min-height: 0;
    overflow: hidden;
  }

  @media (max-width: 900px) {
    height: auto;
    min-height: var(--real-vh);
    grid-template-rows: auto;
    overflow: visible;

    > aside {
      height: auto;
      min-height: 100%;
      overflow: visible;
    }
  }
`;

export const StudentScrollableMain = styled(StudentMain)`
  height: 100%;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 900px) {
    height: auto;
    overflow-y: visible;
  }
`;
